import {ErrorDetail} from 'gen-ts-googleapis';

export class GrpcError extends Error {
  message: string;
  grpcErrorCode?: number;
  public details?: ErrorDetail[];
  constructor(message: string, grpcErrorCode?: number) {
    super(message);
    this.message = message;
    this.grpcErrorCode = grpcErrorCode;
  }
}
